import { Type } from 'class-transformer';
import { APAdjustmentEditorResultDto } from './ap-adjustment-editor-result-dto';
import { DimensionOptionResultDto } from '../../common/dimensions/dimension-option-result-dto';
import { VendorLineItemTemplateRawDto } from '../../../../../shared-workflow-module/_models/vendor-lineItem-template-raw-dto';

export class APAdjustmentEditorForApplyPaymentWithAPCMResultDto {
    @Type(() => APAdjustmentEditorResultDto)
    editor: APAdjustmentEditorResultDto;

    @Type(() => VendorLineItemTemplateRawDto)
    vendorLineItemTemplates: VendorLineItemTemplateRawDto[];

    requireDimensionMatch: boolean;

    @Type(() => DimensionOptionResultDto)
    paymentRequiredDimensions: DimensionOptionResultDto[];
}
